import { Component, OnInit, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { LoginComponent } from 'src/app/authentication/login/login.component';
import { ActivatedRoute, Router } from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  isCollapsed = true;
  svgContent: any;
  sidenaveOpen:any;



  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private _el: ElementRef,
    private router: Router,
    private route: ActivatedRoute
  ) {
    if(this.router.url == '/signin'){
      this.SignInOpen();
    }

  }

  ngOnInit(): void {
    this.loadSVG();

    let x = setInterval(() =>{
      let sidnave =  (<HTMLInputElement>document.querySelector('#offcanvas1'));
      this.sidenaveOpen = sidnave?.getAttribute('aria-modal');
    },1000)

    //close sidnav mobile on click body
    $(document).on('click', (event)=> {
      if(this.sidenaveOpen){
        // Check if click is outside the offcanvas and not on the toggle button
        if (!$(event.target).closest('#offcanvas1').length &&
            !$(event.target).closest('.navbar-toggler').length) {
          document?.getElementById('homePageMobSidNav')?.click();
        }
      }
    });
  }


  loadSVG() {
    this.http.get('../../../../../assets/SVG/logo.svg', { responseType: 'text' })
      .subscribe(svgData => {
        this.svgContent = this.sanitizer.bypassSecurityTrustHtml(svgData);
      });
  }
  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  showOffCanvas(){
    $('#offcanvas1')?.show();
  }

  SignInOpen() {

    console.log(document.getElementById("offcanvas1"));

    $('#offcanvas1')?.hide();

    const dialogRef = this.dialog.open(LoginComponent, {
      width: "40%",
      id:'sign-in-model',
      data: {
        userType: {
          titleOne: 'Add Your',
          titleTwo: 'Organization',
          text: "Be the MVP! Set your team up with game day meals from local restaurants with ease. Just sign up, add your events and select from a variety of restaurants. Share your team codes and you're set for the season.",
          user: 2,
          imgPath: '../../../assets/image/landing-page-2.png'
        }
      },
    });

    // dialogRef.afterClosed().subscribe(result => {
    //   this.router.navigate(['../'], { relativeTo: this.route });
    //   console.log("from here the header");
    // });
  }

  scrollDownToContactus(){
    var element:any = document.querySelector('body');

    element.scrollTo({
      top: element.scrollHeight,
      behavior: 'smooth',
    })
  }

  scrollDownToAboutus(){

    var element:any = document.querySelector('body');
    console.log(element.scrollHeight)
    element.scrollTo({
      top: element.scrollHeight - 1320,
      behavior: 'smooth',
    })
  }

  onClickLogo(){
    this.router.navigateByUrl('/');
    location.reload();
  }
}

// $('body').click(function() {
//     $("#offcanvas1").hide();
// });

// $('#offcanvas1').click(function(e) {
//     e.stopPropagation();
// });

// @Component({
//   selector: 'SignIn',
//   templateUrl: '../../../authentication/login/login.component.html',
//   standalone: true,
//   imports: [MatDialogModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule],
// })
// export class DialogContentExampleDialog {

//   hide = true;

//   constructor(
//     private http: HttpClient,
//     private sanitizer: DomSanitizer,
//     public dialog: MatDialog
//     ) { }


//     SignUpClick(){
//       try{
//         this.hide = true;
//         const dialogConfig = new MatDialogConfig();

//         dialogConfig.disableClose = true;
//         dialogConfig.autoFocus = true;

//         const dialogRef = this.dialog.open(SignUpDialog,  dialogConfig);


//         dialogRef.afterClosed().subscribe(result => {
//           console.log(`Dialog result: ${result}`);
//         });
//       }
//       catch(e){}
//     }

// }

// @Component({
//   selector: 'SignUp',
//   templateUrl: '../../../authentication/signup/signup.component.html',
//   standalone: true,
//   imports: [MatDialogModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule],
// })
// export class SignUpDialog {
// }

